import type React from 'react';
import { getNodeTestIdProp } from '@/utils';
import { ShiftRegister } from './components';

/**
 * Shifts — the admin app's shift register for the branch. A composition page:
 * the register section owns its filters, data, loading and failures. The
 * layout shows the page title.
 */
export const Shifts: React.FC = () => (
    <div
        className="flex w-full flex-col gap-6"
        {...getNodeTestIdProp('shifts-page')}
    >
        <ShiftRegister />
    </div>
);
